import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { useRoutingInfo } from "../../context/RoutingInfoContext"

const ViewName = Steps.MOST_HELPFUL_DECISION
export default function MostHelpfulDecisionStep(): JSX.Element {
  const { routingData } = useRoutingInfo()
  const mostHelpfulValue = routingData?.mostHelpfulNow
  const memberSelectsValue = [
    "DISCUSS_OPTIONS",
    "HELP_PATHWAY",
    "HELP_FINDING_PROVIDER",
    "CHAT_FERTILITY",
    "CHAT_LIFESTYLE",
    "CHAT_HEALTH",
    "LGBTQ_FAMILY"
  ].includes(mostHelpfulValue)
    ? mostHelpfulValue
    : "OTHER_ANSWERS"
  const { setNextStep } = useStateMachine(ViewName, memberSelectsValue)
  useEffect(() => {
    setNextStep(ViewName, memberSelectsValue)
  })
  return <></>
}
